<template>
  <div class="form-personal">
    <div class="form-personal-body">
      <b-row class="form-personal-body__left">
        <b-col v-for="col in columnsTop" :key="col.field" md="6">
          <validation-observer :ref="`simpleRules${col.field}`">
            <validation-provider
              #default="{ errors }"
              :name="col.label"
              :rules="col.formOption ? col.formOption.rules : ''"
            >
              <div
                v-if="col.auditing"
                style="padding-left:15px;display:inline-block;"
              >
                <label :class="{ required: hasRequired(col.formOption) }"
                  >{{ col.label }}:</label
                ><br />
                <b-badge
                  v-b-tooltip.hover.focus.v-primary
                  variant="primary"
                  class="cursor-pointer"
                  :title="
                    `${col.auditData.createStaff.realName}: ${col.auditData.createTime}`
                  "
                >
                  <span>
                    {{
                      col.auditData.oldDataName
                        ? col.auditData.oldDataName
                        : col.auditData.oldData
                    }}
                  </span>
                  <feather-icon icon="ArrowRightIcon" size="20" />
                  <span class="text-warning">
                    {{
                      col.auditData.newDataName
                        ? col.auditData.newDataName
                        : col.auditData.newData
                    }}
                  </span>
                </b-badge>
              </div>
              <div
                v-else-if="col.disabled || disabled"
                style="padding-left:15px;display:inline-block;"
              >
                <label
                  class="mcc-form-label"
                  :class="{ required: hasRequired(col.formOption) }"
                  >{{ col.label }}:</label
                ><br />
                <p class="text-primary">
                  {{ form[col.fieldDict ? col.fieldDict : col.field] }}
                </p>
              </div>
              <form-item
                v-else
                :form-label="col.label"
                :required="hasRequired(col.formOption)"
                :form-value="form[col.fieldDict ? col.fieldDict : col.field]"
                @saveFormItem="update($event, col.field)"
                @clearFormItem="clearFormItem(col.field)"
              >
                <template slot="labelSmall">
                  <small class="text-danger">{{ errors[0] }}</small>
                </template>
                <element-component
                  :id="`v-add-${col.field}`"
                  v-model="reform[col.field]"
                  :state="errors.length > 0 ? false : null"
                  :label="col.label"
                  :option="col"
                  :disabled="col.disabled"
                />
              </form-item>
            </validation-provider>
          </validation-observer>
        </b-col>
      </b-row>
      <div class="form-personal-body__right">
        <c-upload
          v-model="form.attach"
          :disabled="disabled"
          :limit="1"
          @change="updatePhoto"
        />
      </div>
    </div>

    <div class="form-personal-line" />

    <b-row>
      <b-col v-for="col in columnsBottom" :key="col.field" md="4">
        <validation-observer :ref="`simpleRules${col.field}`">
          <validation-provider
            #default="{ errors }"
            :name="col.label"
            :rules="col.formOption ? col.formOption.rules : ''"
          >
            <div
              v-if="col.auditing"
              style="padding-left:15px;display:inline-block;"
            >
              <label :class="{ required: hasRequired(col.formOption) }"
                >{{ col.label }}:</label
              ><br />
              <b-badge
                v-b-tooltip.hover.focus.v-primary
                variant="primary"
                class="cursor-pointer"
                :title="
                  `${col.auditData.createStaff.realName}: ${col.auditData.createTime}`
                "
              >
                <span>
                  {{
                    col.auditData.oldDataName
                      ? col.auditData.oldDataName
                      : col.auditData.oldData
                  }}
                </span>
                <feather-icon icon="ArrowRightIcon" size="20" />
                <span class="text-warning">
                  {{
                    col.auditData.newDataName
                      ? col.auditData.newDataName
                      : col.auditData.newData
                  }}
                </span>
              </b-badge>
            </div>
            <div
              v-else-if="col.disabled || disabled"
              style="padding-left:15px;display:inline-block;"
            >
              <label
                class="mcc-form-label"
                :class="{ required: hasRequired(col.formOption) }"
                >{{ col.label }}:</label
              ><br />
              <p class="text-primary">
                {{ form[col.fieldDict ? col.fieldDict : col.field] }}
              </p>
              <small class="text-primary">{{ col.small }}</small>
            </div>
            <form-item
              v-else
              :required="hasRequired(col.formOption)"
              :form-label="col.label"
              :form-field="col.field"
              :form-value="form[col.fieldDict ? col.fieldDict : col.field]"
              :only-show="col.hideEdit"
              @saveFormItem="update($event, col.field)"
              @clearFormItem="clearFormItem(col.field)"
              @changeEdit="changeEdit(col.field)"
            >
              <template slot="labelSmall">
                <small class="text-danger">{{ errors[0] }}</small>
                <small
                  v-if="showEmailDuplicated && col.field == 'email'"
                  class="text-danger"
                >
                  The Email you entered is duplicated
                </small>
                <small
                  v-if="showMobileDuplicated && col.field == 'mobile'"
                  class="text-danger"
                >
                  The Email you entered is duplicated
                </small>
              </template>

              <div
                v-if="col.field === 'mobile'"
                style="height: 39px;"
                :class="{
                  duplicatedBox: showMobileDuplicated,
                  NoduplicatedBox: showMobileSuccess,
                }"
              >
                <el-input
                  placeholder="Mobile"
                  v-model="reform.mobile"
                  type="number"
                  @input="mobileInput"
                >
                  <el-select
                    style="width: 90px"
                    v-model="reform.mobileCode"
                    slot="prepend"
                    filterable
                    :filter-method="customFilter"
                    @change="mobileCodeChange"
                  >
                    <el-option
                      v-for="country in filteredCountries"
                      :key="country.code"
                      :label="country.nameLabel"
                      :value="country.zone"
                    >
                    </el-option>
                  </el-select>
                  <i
                    v-if="showMobileSuccess"
                    slot="append"
                    class="el-icon-circle-check"
                  ></i>
                  <i
                    v-if="showMobileDuplicated"
                    slot="append"
                    class="el-icon-circle-close"
                  ></i>
                </el-input>
              </div>
              <div
                v-else-if="col.field === 'email'"
                :class="{
                  duplicatedBox: showEmailDuplicated,
                  NoduplicatedBox: showEmailSuccess,
                }"
              >
                <el-input
                  placeholder="Email"
                  v-model="reform.email"
                  @input="emailInput"
                >
                  <i
                    v-if="showEmailSuccess"
                    slot="append"
                    class="el-icon-circle-check"
                  ></i>
                  <i
                    v-if="showEmailDuplicated"
                    slot="append"
                    class="el-icon-circle-close"
                  ></i>
                </el-input>
              </div>
              <element-component
                v-else
                :id="`v-add-${col.field}`"
                v-model="reform[col.field]"
                :state="errors.length > 0 ? false : null"
                :label="col.label"
                :option="col"
                :disabled="col.disabled"
              />
            </form-item>
          </validation-provider>
        </validation-observer>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ElementComponent from '@/components/elementComponent.vue'
import CUpload from '@/components/upload/index.vue'
import FormItem from '@/components/FormItem.vue'
import { BFormInput, BCol, BRow, BBadge, VBTooltip } from 'bootstrap-vue'
import { staff } from '@/api/staff/index'
import Ripple from 'vue-ripple-directive'
import { deepClone } from '@/util/util'
import { formatPhoneNumber } from '@/util/util'
import countryCode from '@/util/mobileCode'
export default {
  components: {
    FormItem,
    BCol,
    BRow,
    ElementComponent,
    ValidationProvider,
    ValidationObserver,
    CUpload,
    BBadge,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    // 修改刷新的回调
    refreshChange: {
      type: Function,
      default: (done) => {
        done()
      },
    },
    auditData: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    const newCountryCode = countryCode
    this.countries = newCountryCode
    this.filteredCountries = [...this.countries]
  },
  data() {
    return {
      oldVal: '',
      // 需要number转string的类型
      hasToStringTypes: ['select'],
      reform: { mobileCode: '' },
      countries: [],
      filteredCountries: [],
      showMobileDuplicated: false,
      showMobileSuccess: false,
      showEmailDuplicated: false,
      showEmailSuccess: false,
    }
  },
  computed: {
    columnsTop() {
      const columns = [
        {
          label: this.i18n('label.enName'),
          field: 'enName',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.cnName'),
          field: 'cnName',
        },
        {
          label: this.i18n('label.nationality'),
          field: 'nationality',
          fieldDict: 'nationalityName',
          type: 'select',
          dictCode: 'nationality',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.sex'),
          field: 'sex',
          fieldDict: 'sexName',
          type: 'select',
          dictBizCode: 'gender',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.birthday'),
          field: 'birthday',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.nric'),
          field: 'nric',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.marriageStatus'),
          field: 'marriageStatus',
          fieldDict: 'marriageStatusName',
          type: 'select',
          dictBizCode: 'staff_marital_status',
          formOption: {
            rules: 'required',
          },
        },
      ]
      const result = []
      columns.forEach((col) => {
        const param = col
        if (Array.isArray(this.auditData)) {
          this.auditData.forEach((item) => {
            if (col.field === item.field) {
              param.auditing = true
              param.auditData = item
            }
          })
        }
        result.push(param)
      })
      return result
    },
    columnsBottom() {
      const columns = [
        {
          label: this.i18n('label.mobile'),
          field: 'mobile',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('labelEmployment.status'),
          field: 'status',
          type: 'select',
          fieldDict: 'statusName',
          dictBizCode: 'staff_status',
          // disabled: true,
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.email'),
          field: 'email',
          formOption: {
            rules: 'required|email',
          },
        },
        {
          label: this.i18n('label.passportNumber'),
          field: 'passportNumber',
        },
        {
          label: this.i18n('label.passportExpiryDate'),
          field: 'passportExpiryDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
          disabled: !this.data.passportNumber,
        },
        {
          label: this.i18n('label.passportIssuancePlace'),
          field: 'passportIssuancePlace',
          disabled: !this.data.passportNumber,
        },
        {
          label: this.i18n('label.postcode'),
          field: 'postcode',
        },
        {
          label: this.i18n('label.address'),
          field: 'address',
        },
        {
          label: this.i18n('label.vaccinationStatus'),
          field: 'vaccinationStatus',
          fieldDict: 'vaccinationStatusName',
          type: 'select',
          dictBizCode: 'vaccination_status',
        },
        {
          label: this.i18n('label.religion'),
          field: 'religion',
          fieldDict: 'religionName',
          type: 'select',
          dictBizCode: 'religion',
        },
        {
          label: this.i18n('label.race'),
          field: 'race',
          fieldDict: 'raceName',
          type: 'select',
          dictBizCode: 'race',
        },
        {
          label: this.i18n('label.idType'),
          field: 'idType',
          fieldDict: 'idTypeName',
          type: 'select',
          dictBizCode: 'id_type',
        },
        {
          label: this.i18n('label.birthCountry'),
          field: 'birthCountry',
          fieldDict: 'birthCountryName',
          type: 'select',
          dictCode: 'nationality',
        },
        {
          label: this.i18n('label.birthCity'),
          field: 'birthCity',
          fieldDict: 'birthCityName',
          type: 'select',
          dictCode: 'city',
          dictQuery: {
            code: this.data.birthCountry,
          },
          disabled: !this.data.birthCountry,
        },
        {
          label: this.i18n('label.highestEducation'),
          field: 'highestEducation',
          fieldDict: 'highestEducationName',
          type: 'select',
          dictBizCode: 'qualification',
        },
        // 新增字段
        {
          label: this.i18n('label.familyWorkpass'),
          field: 'familyWorkpass',
          type: 'select',
          dictBizCode: 'familyWorkpass',
        },
        {
          label: this.i18n('label.foreignId'),
          field: 'foreignId',
        },
        {
          label: this.i18n('label.foreignAddress'),
          field: 'foreignAddress',
        },
        {
          label: this.i18n('label.firstApprover'),
          field: 'firstApprover',
          fieldDict: 'firstApproverName',
          type: 'select',
          dictCode: 'staff',
        },
        {
          label: this.i18n('label.secondApprover'),
          field: 'secondApprover',
          fieldDict: 'secondApproverName',
          type: 'select',
          dictCode: 'staff',
        },
        {
          label: this.i18n('label.assessmentApprover'),
          field: 'assessmentApprover',
          fieldDict: 'assessmentApproverName',
          type: 'select',
          multiple: true,
          dictCode: 'staff',
        },
        {
          label: this.i18n('label.cnCity'),
          field: 'cnCity',
        },
        {
          label: this.i18n('label.annualLeaveCategory'),
          field: 'annualLeaveCategory',
          type: 'select',
          fieldDict: 'annualLeaveCategoryName',
          dictBizCode: 'annual_leave_category',
        },
        {
          label: this.i18n('label.childIsSingapore'),
          field: 'childIsSingapore',
          fieldDict: 'childIsSingaporeName',
          disabled: true,
        },
        {
          label: this.i18n('label.minChildAge'),
          field: 'minChildAge',
          disabled: true,
        },
        {
          label: this.i18n('label.workerAge'),
          field: 'workerAge',
          disabled: true,
        },
      ]
      const result = []
      columns.forEach((col) => {
        const param = col
        if (Array.isArray(this.auditData)) {
          this.auditData.forEach((item) => {
            if (col.field === item.field) {
              param.auditing = true
              param.auditData = item
            }
          })
        }
        result.push(param)
      })
      return result
    },
    form() {
      const res = this.data
      const cols = [this.columnsTop, this.columnsBottom]
      for (let i = 0; i < cols.length; i += 1) {
        const element = cols[i]
        element.forEach((item) => {
          const val = res[item.field]
          if (val || val === 0) {
            const formatVal =
              this.hasToStringTypes.indexOf(item.type) !== -1
                ? val.toString()
                : val
            res[item.field] = formatVal
          }
        })
      }
      return res
    },
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(e) {
        this.reform = deepClone(e)
        if (e.mobile) {
          e.mobile = formatPhoneNumber(e.mobile)
          e.mobileCode = ''
        }
      },
    },
  },
  methods: {
    // 国际化
    i18n(param) {
      return this.$t(`_staff.${param}`)
    },
    mobileInput(e) {
      clearTimeout(this.mobileTimer)
      this.mobileTimer = setTimeout(() => {
        if (e != '') {
          this.verifyContent(`${this.reform.mobileCode} ${e}`, 1)
        } else {
          this.showMobileDuplicated = false
          this.showMobileSuccess = false
        }
      }, 1000)
    },
    mobileCodeChange(e) {
      clearTimeout(this.mobileTimer)
      this.mobileTimer = setTimeout(() => {
        if (e != '') {
          this.verifyContent(`${e} ${this.reform.mobile}`, 1)
        } else {
          this.showMobileDuplicated = false
          this.showMobileSuccess = false
        }
      }, 1000)
    },
    emailInput(e) {
      clearTimeout(this.emailTimer)
      this.emailTimer = setTimeout(() => {
        if (e != '') {
          this.verifyContent(`${e}`, 2)
        } else {
          this.showEmailDuplicated = false
          this.showEmailSuccess = false
        }
      }, 1000)
    },
    verifyContent(content, type) {
      staff
        .verifyRepeat({
          verifyContent: content,
          verifyType: type,
        })
        .then((res) => {
          console.log(res)
          const haveSame = res.data.data
          if (type == 1) {
            this.showMobileDuplicated = haveSame
            this.showMobileSuccess = !haveSame
          }
          if (type == 2) {
            console.log('sdff email', haveSame)
            this.showEmailDuplicated = haveSame
            this.showEmailSuccess = !haveSame
          }
          if (type == 0) {
            console.log('sdff staffNo', haveSame)
            this.showStaffNoDuplicated = haveSame
            this.showStaffNoSuccess = !haveSame
          }
        })
    },
    customFilter(query) {
      // en: item.en,
      //   cn: item.cn,
      //   code: item.code,
      //   zone
      console.log(query)
      const searchTerm = query.toLowerCase()

      this.filteredCountries = this.countries.filter((country) => {
        return (
          country.en.toLowerCase().includes(searchTerm) || // 匹配国家名称
          country.cn.toLowerCase().includes(searchTerm) ||
          country.code.toLowerCase().includes(searchTerm) ||
          country.zone.toLowerCase().includes(searchTerm)
          // 匹配区号
        )
      })
    },
    extractPhoneNumber(str) {
      // 去除字符串首尾可能存在的空格
      str = str.trim()
      let plusSignRemoved = str
      // 如果字符串以 '+' 开头，去除 '+'
      if (str.startsWith('+')) {
        plusSignRemoved = str.slice(1)
      }
      // 正则匹配区号和手机号，假设区号和手机号都是数字，以空格分隔
      const match = plusSignRemoved.match(/^(\d+)\s+(\d+)$/)
      if (match) {
        return {
          areaCode: '+' + match[1],
          phoneNumber: match[2],
        }
      }
      // 如果没有匹配到区号和手机号的格式，直接返回手机号
      return {
        areaCode: '',
        phoneNumber: str,
      }
    },

    update(done, key) {
      console.log(key, 'ss')
      if (key == 'email' && this.showEmailDuplicated) {
        console.log('email重复')
        return
      }
      if (key == 'mobile' && this.showMobileDuplicated) {
        console.log('mobile重复')
        return
      }

      this.$refs[`simpleRules${key}`][0].validate().then((success) => {
        if (success) {
          const params = { id: this.form.id }

          console.log(this.reform)
          if (this.reform.mobileCode && key === 'mobile') {
            params[key] = `${this.reform.mobileCode} ${this.reform.mobile}`
          } else {
            params[key] = deepClone(this.reform[key]) || ''
          }
          staff.update(params, { key }).then((res) => {
            let isDone = false
            const refreshDone = () => {
              if (!isDone) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: this.$t('_default.toast.title'),
                    icon: 'BellIcon',
                    text: this.$t('_default.toast.text.success'),
                    variant: 'success',
                  },
                })
                done()
                isDone = true
              }
            }
            this.refreshChange(refreshDone)
          })
        }
      })
    },
    updatePhoto(e) {
      const params = {
        id: this.form.id,
        photo: e.map((o) => o.attachId).join(),
      }
      const key = 'photo'
      staff.update(params, { key }).then((res) => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
      })
    },
    changeEdit(e) {
      console.log('sssss', e)
      if (e === 'mobile') {
        console.log(this.reform.mobile)
        console.log(this.extractPhoneNumber(this.reform.mobile))
        const mobileObj = this.extractPhoneNumber(this.reform.mobile)
        this.reform.mobile = mobileObj.phoneNumber
        this.reform.mobileCode = mobileObj.areaCode
      }
    },
    hasRequired(option = {}) {
      const rules = option.rules || ''
      return rules.indexOf('required') !== -1
    },
    clearFormItem(key) {
      this.reform[key] = deepClone(this.form[key])
    },
  },
}
</script>

<style lang="scss" scoped>
.form-personal {
  &-line {
    width: 100%;
    border-bottom: 1px solid #cad6eb;
    margin-bottom: 1rem;
  }
  &-body {
    display: flex;
    &__left {
      width: 68%;
    }
    &__right {
      width: 32%;
      position: relative;
    }
  }
}
.NoduplicatedBox {
  ::v-deep .el-input__inner {
    border-color: #67c23a;
    border-right: none;
  }
  ::v-deep .el-input-group__append {
    border-color: #67c23a;
    background-color: #fff;
    i {
      color: #67c23a !important;
    }
  }
  ::v-deep .el-input-group__prepend {
    border-color: #67c23a;
  }
  .duplicated_msg {
    color: #f56c6c;
  }
}
.duplicatedBox {
  ::v-deep .el-input__inner {
    border-color: #f56c6c;
    border-right: none;
  }
  ::v-deep .el-input-group__append {
    border-color: #f56c6c;
    background-color: #fff;
    i {
      color: #f56c6c !important;
    }
  }
  ::v-deep .el-input-group__prepend {
    border-color: #f56c6c;
  }
  .duplicated_msg {
    color: #f56c6c;
  }
}
</style>

<style lang="scss">
.form-personal {
  .upload-image {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
}
</style>
